// app/src/lib/device.ts
// In production this is established during device registration & approval
// (Plan §8.1). For the demo it points at the seeded register/branch.

export interface DeviceConfig {
  device_id: string;
  register_id: string;
  branch_id: string;
  branch_code: string;
  currency_symbol: string;
}

const STORAGE_KEY = "epos.device";

const DEMO: DeviceConfig = {
  device_id: "dev_demo_1",
  register_id: "reg_1",
  branch_id: "br_main",
  branch_code: "BR1",
  currency_symbol: "£",
};

export function getDevice(): DeviceConfig {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw) {
    try {
      const cfg = JSON.parse(raw);
      if (!cfg.currency_symbol || cfg.currency_symbol === "$") { cfg.currency_symbol = "£"; localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg)); }
      return cfg;
    } catch { /* fall through */ }
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(DEMO));
  return DEMO;
}

export function setCurrencySymbol(symbol: string): void {
  const cfg = getDevice();
  cfg.currency_symbol = symbol;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg));
}

const SHIFT_KEY = (reg: string) => `epos.shift.${reg}`;
export function getShiftId(registerId: string): string | null {
  return localStorage.getItem(SHIFT_KEY(registerId));
}
export function setShiftId(registerId: string, shiftId: string | null): void {
  if (shiftId) localStorage.setItem(SHIFT_KEY(registerId), shiftId);
  else localStorage.removeItem(SHIFT_KEY(registerId));
}
